/**
 * Infinite Scroll Handler
 *
 * Loads more posts as the user scrolls down the page
 */
(function() {
	'use strict';

	const InfiniteScroll = {
		sentinel: null,
		isLoading: false,
		observer: null,

		init() {
			this.sentinel = document.querySelector('.infinite-scroll-sentinel');

			if (!this.sentinel) {
				return; // Not on an archive page
			}

			// Check if there's more than one page
			const maxPages = parseInt(this.sentinel.getAttribute('data-max-pages'), 10);
			if (maxPages <= 1) {
				return; // No need for infinite scroll if only one page
			}

			// Set up Intersection Observer
			this.setupObserver();
		},

		setupObserver() {
			const options = {
				root: null,
				rootMargin: '500px',
				threshold: 0
			};

			this.observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && !this.isLoading) {
						this.loadMore();
					}
				});
			}, options);

			this.observer.observe(this.sentinel);
		},

		loadMore() {
			if (this.isLoading) {
				return;
			}

			this.isLoading = true;

			const nextPage = parseInt(this.sentinel.getAttribute('data-next-page'), 10);
			const maxPages = parseInt(this.sentinel.getAttribute('data-max-pages'), 10);
			const postType = this.sentinel.getAttribute('data-post-type');

			// Get current taxonomy if we're on a filtered archive page
			const urlParams = new URLSearchParams(window.location.search);
			const tax = urlParams.get('type') || '';

			const formData = new FormData();
			formData.append('action', 'nsot_load_more_posts');
			formData.append('page', nextPage);
			formData.append('post_type', postType);
			formData.append('nonce', window.localVars?.nonce || '');

			if (tax) {
				formData.append('tax', tax);
			}

			fetch(window.localVars?.ajax_url || '/wp-admin/admin-ajax.php', {
				method: 'POST',
				body: formData
			})
				.then(response => response.json())
				.then(data => {
					this.isLoading = false;

					if (data.success && data.data.html) {
						// Find the container and append new posts
						const container = document.querySelector('.projects-archive');
						if (container) {
							container.insertAdjacentHTML('beforeend', data.data.html);
						}

						// Update the sentinel attributes for the next page
						this.sentinel.setAttribute('data-next-page', nextPage + 1);

						// If there are no more pages, stop observing
						if (!data.data.has_more || nextPage >= maxPages) {
							this.observer.unobserve(this.sentinel);
						}
					} else {
						// Stop loading if there was an error or no more posts
						this.observer.unobserve(this.sentinel);
					}
				})
				.catch(error => {
					console.error('Error loading more posts:', error);
					this.isLoading = false;
					this.observer.unobserve(this.sentinel);
				});
		}
	};

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			InfiniteScroll.init();
		});
	} else {
		InfiniteScroll.init();
	}
})();
